export default __webpack_public_path__ + "static/media/first.4245ab5e.png";